// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1BXZj","loaderOuter":"PageOverlayLoader_loaderOuter__1SP3n"};